import React, { useEffect, useState } from "react";
import { RESPONSE_TIME_FOR_CREATOR } from "../../utils/Enviroment";

const DisputeResponseTimer = ({ time, hasCreatorRole, setTimeLeftInResponse }) => {
    const [timeLeft, setTimeLeft] = useState(0);

    useEffect(() => {
        if (!time) return;

        const createdAtTimestamp = Math.floor(new Date(time[0]?.createdAt).getTime() / 1000);

        const interval = setInterval(() => {
            const now = Math.floor(Date.now() / 1000);
            const elapsed = now - createdAtTimestamp;
            const remaining = RESPONSE_TIME_FOR_CREATOR - elapsed;

            if (remaining <= 0) {
                setTimeLeftInResponse(true)
                setTimeLeft(0);
                clearInterval(interval);
            } else {
                setTimeLeft(remaining);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [time]);

    const days = Math.floor(timeLeft / 86400);
    const hours = Math.floor((timeLeft % 86400) / 3600);
    const minutes = Math.floor((timeLeft % 3600) / 60);
    const seconds = timeLeft % 60;

    const formattedTime = `${days}D : ${hours}H : ${minutes}M : ${seconds < 10 ? "0" + seconds : seconds
        }S`;

    return (
        <>
            {!hasCreatorRole && timeLeft > 0 && (
                <div className="dispute-date">
                    <p>Time left to submit dispute response</p>
                    <h6>{formattedTime}</h6>
                </div>
            )}

            {!hasCreatorRole && timeLeft === 0 && (
                <div className="dispute-date">
                    <p>Dispute response time has ended</p>
                </div>
            )}
        </>
    );
};

export default DisputeResponseTimer;
